import { render, staticRenderFns } from "./avatars_inline.vue?vue&type=template&id=2f17519c"
import script from "./avatars_inline.vue?vue&type=script&lang=js"
export * from "./avatars_inline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports